export default __webpack_public_path__ + "static/media/Seb7.7ab81436.jpg";